export default __webpack_public_path__ + "static/media/warranties-empty.140e4e82.svg";